import { render, staticRenderFns } from "./MaterialPriceTable.vue?vue&type=template&id=083a33bf&scoped=true&"
import script from "./MaterialPriceTable.vue?vue&type=script&lang=js&"
export * from "./MaterialPriceTable.vue?vue&type=script&lang=js&"
import style0 from "./MaterialPriceTable.vue?vue&type=style&index=0&id=083a33bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083a33bf",
  null
  
)

export default component.exports